<template>
  <div>
    <div class="split-box">
      <div class="split-line"></div>
      <div class="split-name">【项目报名/竞价(比选)时间】</div>
    </div>
    <div class="view-row">
      <el-form
        :model="Project"
        ref="ruleForm"
        label-position="right"
        class="mainfrom"
      >
        <div class="row">
          <el-form-item label="报名开始" prop="prsbmbegtime" verify>
            <el-date-picker
              v-model="Project.prsbmbegtime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="报名截止" prop="prsbmendtime">
            <el-date-picker
              v-model="Project.prsbmendtime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
            <!--            <el-checkbox v-model="Project.prsbmneedconfirm">报名需要确认</el-checkbox>-->
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item :label="`报价开始`" prop="prsbjbegtime">
            <el-date-picker
              v-model="Project.prsbjbegtime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>

          <el-form-item :label="`报价截止`" prop="prsbjendtime">
            <el-date-picker
              v-model="Project.prsbjendtime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="row">
          <el-button
            type="primary"
            @click="updateProjectTime"
            style="margin-left: 50px"
            >保存</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import utils from "../../../assets/js/utils";
export default {
  name: "BiddingTimeStatus",
  data() {
    return {
    };
  },
  props: { Project: Object },
  computed: {
    prsflgName() {
      if (this.Project.prsflg == "2") {
        return "开标";
      } else if (this.Project.prsflg == "1" || this.Project.prsflg == "3") {
        return "竞价";
      } else if (this.Project.prsflg == "4" || this.Project.prsflg == "5") {
        return "竞拍";
      } else if (this.Project.prsflg == "6") {
        return "比选";
      }
    },
  },
  methods: {
    async updateProjectTime() {
      this.$confirm("是否确定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await request({
            url: "/xtgl/status/updateProjectTime",
            method: "post",
            data: {
              projectid: this.Project.projectid,
              prsbmbegtime: utils.formatterDate(
                this.Project.prsbmbegtime,
                "yyyy-MM-dd HH:mm:ss"
              ),
              prsbmendtime: utils.formatterDate(
                this.Project.prsbmendtime,
                "yyyy-MM-dd HH:mm:ss"
              ),
              prsbjbegtime: utils.formatterDate(
                this.Project.prsbjbegtime,
                "yyyy-MM-dd HH:mm:ss"
              ),
              prsbjendtime: utils.formatterDate(
                this.Project.prsbjendtime,
                "yyyy-MM-dd HH:mm:ss"
              ),
            },
          });

          if (+res.issuccess === 1) {
            this.$message.success("更新成功");
            this.getModel();
          }
          this.loading = false;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;
  .split-line {
    margin: 5px;
  }
  .split-name {
    font-weight: bold;
  }
}
</style>
